import { Injectable } from '@angular/core';

export interface TablePreferences {
  visibleColumns?: string[];
  density?: 'compact' | 'normal' | 'comfortable';
  view?: string;
  columnWidths?: Record<string, string>;
  sort?: { sortBy: string; direction: 'asc' | 'desc' };
}

@Injectable({ providedIn: 'root' })
export class TablePreferencesService {
  private storageKey(tableId: string): string {
    return `table_prefs_${tableId}`;
  }

  load(tableId: string): TablePreferences {
    try {
      const raw = localStorage.getItem(this.storageKey(tableId));
      return raw ? (JSON.parse(raw) as TablePreferences) : {};
    } catch {
      return {};
    }
  }

  save(tableId: string, prefs: TablePreferences): void {
    try {
      const existing = this.load(tableId);
      localStorage.setItem(this.storageKey(tableId), JSON.stringify({ ...existing, ...prefs }));
    } catch {
      // localStorage puede estar bloqueado (modo privado, cuota llena)
    }
  }

  patch(tableId: string, partial: Partial<TablePreferences>): void {
    this.save(tableId, partial);
  }

  clear(tableId: string): void {
    try {
      localStorage.removeItem(this.storageKey(tableId));
    } catch {
      // noop
    }
  }
}
